// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/images/login/login_bg-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/assets/images/login/beo-logo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/assets/images/login/dakz-logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page::before {
  content: "";
  position: absolute;
  height: 100%;
  width: 100%;
  background-image: linear-gradient(
    to right top,
    #513800,
    #804800,
    #6d4200,
    #ffe2c3b2,
    #fff
  );
  pointer-events: none;
  opacity: 0.2;
}

.login-page {
  position: relative;
  height: 100vh;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
}

.beo-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  width: 193px;
  height: 85px;
  position: absolute;
  top: 20px;
  left: 20px;
}

.form-login {
  max-width: 500px;
  padding: 1rem;
  height: 100vh;
  display: flex;
  align-items: center;
}

.body-login {
  background-color: #fff;
  padding: 80px 50px 30px 50px;
  border-radius: 14px;
  box-shadow: inset 0px 0px 36px #b6b6b68a;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(4px);
  width: 100%;
}

.eakz-logo {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  height: 40px;
  padding-bottom: 5rem;
  margin: 0 auto;
  max-width: 210px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/login/login.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX;;;;;;;GAOC;EACD,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,yDAAgE;EAChE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yDAA8D;EAC9D,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,wCAAwC;EACxC,0CAA0C;EAC1C,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,yDAA+D;EAC/D,4BAA4B;EAC5B,YAAY;EACZ,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".login-page::before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  background-image: linear-gradient(\n    to right top,\n    #513800,\n    #804800,\n    #6d4200,\n    #ffe2c3b2,\n    #fff\n  );\n  pointer-events: none;\n  opacity: 0.2;\n}\n\n.login-page {\n  position: relative;\n  height: 100vh;\n  width: 100%;\n  background-image: url(\"/src/assets/images/login/login_bg-1.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n\n.beo-logo {\n  background-image: url(\"/src/assets/images/login/beo-logo.png\");\n  background-repeat: no-repeat;\n  width: 193px;\n  height: 85px;\n  position: absolute;\n  top: 20px;\n  left: 20px;\n}\n\n.form-login {\n  max-width: 500px;\n  padding: 1rem;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n}\n\n.body-login {\n  background-color: #fff;\n  padding: 80px 50px 30px 50px;\n  border-radius: 14px;\n  box-shadow: inset 0px 0px 36px #b6b6b68a;\n  background-color: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(4px);\n  width: 100%;\n}\n\n.eakz-logo {\n  background-image: url(\"/src/assets/images/login/dakz-logo.png\");\n  background-repeat: no-repeat;\n  height: 40px;\n  padding-bottom: 5rem;\n  margin: 0 auto;\n  max-width: 210px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
